/** @jsx jsx */
import { jsx } from "theme-ui";
import React from "react";
import { Box, BoxProps } from "@shared-components/Box/Box";
import { aspectRatioToPadding } from "@styles/utils/aspectRatioToPadding";
export interface AspectRatioProps extends BoxProps {
  ratio: string | string[];
}

const AspectRatio: React.FC<AspectRatioProps> = ({
  ratio,
  sx,
  children,
  ...props
}) => {
  return (
    <Box
      sx={{
        ...sx,
        ...{
          aspectRatio: aspectRatioToPadding(ratio),
          position: "relative",
          overflow: "hidden",
          width: "100%",
        },
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

AspectRatio.defaultProps = {
  ratio: "4:3",
};

export { AspectRatio };
